webpackJsonp([143926653009679],{

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(8);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _Main = __webpack_require__(40);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Article = __webpack_require__(39);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _PageHeader = __webpack_require__(45);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Content = __webpack_require__(44);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Footer = __webpack_require__(104);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {};
	};
	
	var Support = function Support() {
	  return _react2.default.createElement(
	    _Main2.default,
	    null,
	    _react2.default.createElement(
	      _Article2.default,
	      null,
	      _react2.default.createElement(_PageHeader2.default, { title: "Support the site" }),
	      _react2.default.createElement(
	        _Content2.default,
	        null,
	        "I buy all these helmets, and spend hours researching and testing - please consider supporting PSH by participating in the following options:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "-",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "https://www.buymeacoffee.com/surfhelmet", target: "_blank" },
	          "Buying me a coffee"
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "- Clicking on links to products. Although these are independent reviews, when you buy through my links, I may earn a commission from the retailer that sells the product. Please understand, there\u2019s no incentive to pick inferior products or to respond to pressure from manufacturers - in fact, it\u2019s quite the opposite. If a reader returns their purchase, I earn no affiliate commission.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null)
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	Support.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(Support);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-support-js-89bea9abb0c07739a5b9.js